import { editAlert, completeAction } from '../index';
import { isValidation, checkDateFormat, applyCellFormat, activeCellChanged } from '../../workbook/common/event';
import { getCell, setCell } from '../../workbook/base/cell';
import { FormValidator, NumericTextBox } from '@syncfusion/ej2-inputs';
import { EventHandler, remove, closest, isNullOrUndefined, select, Browser } from '@syncfusion/ej2-base';
import { dialog, locale, initiateDataValidation, invalidData, editOperation, keyUp, focus } from '../common/index';
import { formulaBarOperation, removeDataValidation } from '../common/index';
import { CheckBox } from '@syncfusion/ej2-buttons';
import { isHiddenRow, setRow, beginAction, getSwapRange, checkColumnValidation } from '../../workbook/index';
import { getRangeIndexes, getIndexesFromAddress, getCellIndexes, cellValidation, updateCell, isInMultipleRange } from '../../workbook/common/index';
import { getData, isCellReference, parseLocaleNumber } from '../../workbook/index';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { getSheet, getSheetIndex, checkIsFormula } from '../../workbook/index';
import { getColumn, isLocked, getRowsHeight, getColumnsWidth, validationHighlight, formulaInValidation } from '../../workbook/index';
/**
 * Represents Data Validation support for Spreadsheet.
 */
export class DataValidation {
    /**
     * Constructor for the Spreadsheet Data Validation module.
     *
     * @param {Spreadsheet} parent - Constructor for the Spreadsheet Data Validation module.
     */
    constructor(parent) {
        this.data = [];
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * To destroy the Data Validation module.
     *
     * @returns {void}
     */
    destroy() {
        this.removeEventListener();
        const dataValPopup = select('#' + this.parent.element.id + '_datavalidation-popup');
        if (dataValPopup) {
            dataValPopup.remove();
        }
        this.parent = null;
    }
    addEventListener() {
        EventHandler.add(this.parent.element, 'dblclick', this.listOpen, this);
        this.parent.on(initiateDataValidation, this.initiateDataValidationHandler, this);
        this.parent.on(invalidData, this.invalidDataHandler, this);
        this.parent.on(isValidation, this.checkDataValidation, this);
        this.parent.on(activeCellChanged, this.listHandler, this);
        this.parent.on(keyUp, this.keyUpHandler, this);
        this.parent.on(removeDataValidation, this.removeValidationHandler, this);
        this.parent.on(validationHighlight, this.InvalidElementHandler, this);
    }
    removeEventListener() {
        EventHandler.remove(this.parent.element, 'dblclick', this.listOpen);
        if (!this.parent.isDestroyed) {
            this.parent.off(initiateDataValidation, this.initiateDataValidationHandler);
            this.parent.off(invalidData, this.invalidDataHandler);
            this.parent.off(isValidation, this.checkDataValidation);
            this.parent.off(activeCellChanged, this.listHandler);
            this.parent.off(keyUp, this.keyUpHandler);
            this.parent.off(removeDataValidation, this.removeValidationHandler);
            this.parent.off(validationHighlight, this.InvalidElementHandler);
        }
    }
    removeValidationHandler(eventArgs) {
        let sheet;
        let range;
        const args = { cancel: false, isColSelected: eventArgs.isCol };
        let actualRange = eventArgs.range;
        if (eventArgs.range && eventArgs.range.includes('!')) {
            range = eventArgs.range;
            sheet = getSheet(this.parent, getSheetIndex(this.parent, range.split('!')[0]));
            if (!sheet) {
                return;
            }
        }
        else {
            sheet = this.parent.getActiveSheet();
            range = sheet.name + '!';
            if (eventArgs.range) {
                range += eventArgs.range;
            }
            else {
                const rangeArgs = this.getRange(sheet.selectedRange);
                range += rangeArgs.range;
                args.isColSelected = rangeArgs.isColSelected;
            }
        }
        actualRange = sheet.selectedRange;
        args.range = range;
        if (eventArgs.isAction) {
            this.parent.notify(beginAction, { eventArgs: args, action: 'removeValidation' });
        }
        if (!args.cancel) {
            let isListValidation;
            let modelObj;
            let actCelIdx;
            if (sheet.name === this.parent.getActiveSheet().name) {
                actCelIdx = getCellIndexes(sheet.activeCell);
                const indexes = getSwapRange(getRangeIndexes(actualRange));
                if (actCelIdx[0] >= indexes[0] && actCelIdx[1] >= indexes[1] && actCelIdx[0] <= indexes[2] && actCelIdx[1] <= indexes[3]) {
                    modelObj = args.isColSelected ? getColumn(sheet, actCelIdx[1]) || {} :
                        getCell(actCelIdx[0], actCelIdx[1], sheet, false, true);
                    isListValidation = modelObj.validation && modelObj.validation.type === 'List';
                }
            }
            this.parent.notify(cellValidation, { range: range, isRemoveValidation: true, viewport: this.parent.viewport });
            if (isListValidation && !modelObj.validation) {
                const td = this.parent.getCell(actCelIdx[0], actCelIdx[1]);
                if (td && td.getElementsByClassName('e-validation-list')[0]) {
                    this.listObj.destroy();
                    td.removeChild(td.getElementsByClassName('e-validation-list')[0]);
                }
            }
            if (eventArgs.isAction) {
                delete args.cancel;
                this.parent.notify(completeAction, { eventArgs: args, action: 'removeValidation' });
            }
        }
    }
    keyUpHandler(e) {
        const target = e.target;
        const dlgEle = this.parent.element.querySelector('.e-datavalidation-dlg');
        if (closest(target, '.e-values') && dlgEle && e.keyCode !== 13) {
            const valuesCont = dlgEle.querySelector('.e-values');
            const errorEle = valuesCont.querySelector('.e-dlg-error');
            const footerCont = dlgEle.querySelector('.e-footer-content');
            const primaryBut = footerCont.querySelector('.e-primary');
            if (primaryBut.hasAttribute('disabled')) {
                primaryBut.removeAttribute('disabled');
            }
            if (errorEle) {
                valuesCont.removeChild(errorEle);
            }
        }
    }
    listOpen(e) {
        const target = e.target;
        if (this.listObj && target.classList.contains('e-cell') && target.querySelector('.e-validation-list')) {
            this.listObj.showPopup();
        }
    }
    invalidDataHandler(args) {
        const eventArgs = { range: args.range || this.parent.dataValidationRange, cancel: false };
        if (!eventArgs.range) {
            return;
        }
        let actionArgs;
        if (!args.isPublic) {
            actionArgs = { eventArgs: eventArgs, action: args.isRemoveHighlight ? 'removeHighlight' : 'addHighlight' };
            this.parent.notify(beginAction, actionArgs);
            if (eventArgs.cancel) {
                return;
            }
        }
        if (args.isRemoveHighlight) {
            this.parent.removeInvalidHighlight(eventArgs.range);
        }
        else {
            this.parent.addInvalidHighlight(eventArgs.range);
        }
        if (!args.isPublic) {
            this.parent.notify(completeAction, actionArgs);
        }
    }
    listHandler() {
        if (this.parent.allowDataValidation) {
            const sheet = this.parent.getActiveSheet();
            const indexes = getCellIndexes(sheet.activeCell);
            const cell = getCell(indexes[0], indexes[1], sheet);
            const tdEle = this.parent.getCell(indexes[0], indexes[1]);
            if (!tdEle) {
                return;
            }
            if (document.getElementsByClassName('e-validation-list')[0]) {
                remove(document.getElementsByClassName('e-validation-list')[0]);
                this.data = [];
            }
            const validation = (cell && cell.validation) || (sheet.columns && sheet.columns[indexes[1]] &&
                sheet.columns[indexes[1]].validation);
            if (validation && validation.type === 'List') {
                if (validation.address && !isInMultipleRange(validation.address, indexes[0], indexes[1])) {
                    return;
                }
                validation.ignoreBlank = !isNullOrUndefined(validation.ignoreBlank) ? validation.ignoreBlank : true;
                validation.inCellDropDown = !isNullOrUndefined(validation.inCellDropDown) ?
                    validation.inCellDropDown : true;
                if (validation.inCellDropDown) {
                    const ddlCont = this.parent.createElement('div', { className: 'e-validation-list' });
                    const ddlEle = this.parent.createElement('input', { id: this.parent.element.id + 'listValid' });
                    ddlCont.appendChild(ddlEle);
                    if (!validation.inCellDropDown) {
                        ddlCont.style.display = 'none';
                    }
                    const parent = tdEle.getElementsByClassName('e-wrap-content')[0] || tdEle;
                    parent.insertBefore(ddlCont, parent.firstChild);
                    const dataSource = this.updateDataSource(cell, validation);
                    this.listObj = new DropDownList({
                        index: this.setDropDownListIndex(dataSource, cell),
                        dataSource: dataSource,
                        fields: { text: 'text', value: 'id' },
                        width: '0px',
                        popupHeight: '200px',
                        change: () => this.listValueChange(this.listObj.text),
                        open: (args) => {
                            args.popup.offsetX = -(tdEle.offsetWidth - 20) + 4;
                            args.popup.offsetY = -13;
                            args.popup.element.style.width = tdEle.offsetWidth - 1 + 'px';
                            // Positioning popup in mobile device based on transform css applied on virtual element as suggested by dropdown team
                            if (Browser.isDevice && this.parent.scrollModule) {
                                const offset = this.parent.scrollModule.offset;
                                const viewport = this.parent.viewport;
                                args.popup.offsetY += viewport.topIndex ? offset.top.size -
                                    getRowsHeight(sheet, viewport.topIndex + 1, offset.top.idx, true) : 0;
                                args.popup.offsetX += viewport.leftIndex ? offset.left.size -
                                    getColumnsWidth(sheet, viewport.leftIndex + 1, offset.left.idx, true) : 0;
                                args.popup.refresh();
                            }
                        },
                        close: () => focus(this.parent.element)
                    });
                    this.listObj.appendTo('#' + this.parent.element.id + 'listValid');
                }
            }
            if (cell && cell.validation) {
                cell.validation = validation;
            }
        }
    }
    setDropDownListIndex(dataSource, cell) {
        if (cell && cell.value) {
            for (let dataIdx = 0, len = dataSource.length; dataIdx < len; dataIdx++) {
                if (dataSource[dataIdx].text === cell.value.toString()) {
                    return dataIdx;
                }
            }
        }
        return null;
    }
    updateDataSource(cell, validation) {
        this.data = [];
        let count = 0;
        const definedNames = this.parent.definedNames;
        let value = validation.value1;
        const isRange = value.indexOf('=') !== -1;
        if (definedNames.length > 0 && isRange) {
            const listValue = value.split('=')[1];
            for (let idx = 0, len = definedNames.length; idx < len; idx++) {
                if (definedNames[idx].name === listValue) {
                    let definedNameRange = definedNames[idx].refersTo;
                    // eslint-disable-next-line
                    while (definedNameRange.includes("'")) {
                        // eslint-disable-next-line
                        definedNameRange = definedNameRange.replace("'", '');
                    }
                    value = definedNameRange;
                }
            }
        }
        if (isRange) {
            const sheet = value.indexOf('!') > -1 ?
                getSheet(this.parent, getSheetIndex(this.parent, value.split('=')[1].split('!')[0])) : this.parent.getActiveSheet();
            const address = value.indexOf('!') > -1 ? value.split('!')[1] : value.split('=')[1];
            const activeSheet = this.parent.getActiveSheet();
            if (sheet.name !== activeSheet.name) {
                let isNotLoaded;
                const selectedRange = getRangeIndexes(activeSheet.selectedRange);
                sheet.ranges.forEach((range) => {
                    if (!range.info || !range.info.loadedRange || !range.info.loadedRange.length) {
                        isNotLoaded = true;
                        return;
                    }
                });
                if (isNotLoaded) {
                    this.parent.showSpinner();
                    getData(this.parent, `${sheet.name}!${address}`).then(() => {
                        this.parent.hideSpinner();
                        if (activeSheet.name === this.parent.getActiveSheet().name) {
                            const curRange = getRangeIndexes(this.parent.getActiveSheet().selectedRange);
                            if (curRange[0] === selectedRange[0] && curRange[1] === selectedRange[1]) {
                                this.listObj.dataSource = this.updateDataSource(cell, validation);
                                this.listObj.dataBind();
                            }
                        }
                    });
                }
            }
            let indexes;
            const range = address.split(':');
            if ((range[0].match(/[a-z]+$/ig) && range[1].match(/[a-z]+$/ig)) || (range[0].match(/^[0-9]/g) && range[1].match(/^[0-9]/g))) {
                const addressInfo = this.parent.getIndexes(address);
                if (addressInfo.isCol) {
                    indexes = [0, addressInfo.startIdx, sheet.usedRange.rowIndex, addressInfo.startIdx];
                }
                else {
                    indexes = [addressInfo.startIdx, 0, addressInfo.startIdx, sheet.usedRange.colIndex];
                }
            }
            else {
                indexes = getRangeIndexes(address);
            }
            for (let rowIdx = indexes[0]; rowIdx <= indexes[2]; rowIdx++) {
                if (!sheet.rows[rowIdx]) {
                    setRow(sheet, rowIdx, {});
                }
                for (let colIdx = indexes[1]; colIdx <= indexes[3]; colIdx++) {
                    if (!sheet.rows[rowIdx].cells) {
                        setCell(rowIdx, colIdx, sheet, {});
                    }
                    count += 1;
                    cell = sheet.rows[rowIdx].cells[colIdx];
                    const data = this.parent.getDisplayText(cell) || '';
                    this.data.push({ text: data, id: 'list-' + count });
                }
            }
        }
        else {
            const listValues = value.split(',');
            for (let idx = 0; idx < listValues.length; idx++) {
                count += 1;
                this.data.push({ text: listValues[idx], id: 'list-' + count });
            }
        }
        return this.data;
    }
    listValueChange(value) {
        this.parent.notify(formulaBarOperation, { action: 'refreshFormulabar', value: value });
        const sheet = this.parent.getActiveSheet();
        const cellIdx = getIndexesFromAddress(sheet.activeCell);
        const cellObj = Object.assign({}, getCell(cellIdx[0], cellIdx[1], sheet));
        if (sheet.isProtected && isLocked(cellObj, getColumn(sheet, cellIdx[1]))) {
            this.parent.notify(editAlert, null);
        }
        else {
            if (this.parent.isEdit) {
                this.parent.closeEdit();
            }
            const args = { value: value, oldValue: cellObj.value, address: sheet.name + '!' + sheet.activeCell, cancel: false };
            this.parent.notify(beginAction, { action: 'cellSave', eventArgs: args });
            if (args.cancel) {
                return;
            }
            updateCell(this.parent, sheet, { cell: { value: value }, rowIdx: cellIdx[0], colIdx: cellIdx[1], valChange: true, lastCell: true,
                uiRefresh: true, checkCF: true });
            this.parent.notify(completeAction, { action: 'cellSave', eventArgs: { value: value, oldValue: cellObj.value, address: sheet.name + '!' + sheet.activeCell } });
        }
    }
    getRange(range) {
        const indexes = getRangeIndexes(range);
        const sheet = this.parent.getActiveSheet();
        const maxRowCount = sheet.rowCount;
        const maxColCount = sheet.colCount;
        let isColSelected;
        if (indexes[2] === maxRowCount - 1 && indexes[0] === 0) {
            range = range.replace(/[0-9]/g, '');
            isColSelected = true;
        }
        else if (indexes[3] === maxColCount - 1 && indexes[2] === 0) {
            range = range.replace(/\D/g, '');
        }
        return { range: range, isColSelected: isColSelected };
    }
    initiateDataValidationHandler(okClick, noClick) {
        const l10n = this.parent.serviceLocator.getService(locale);
        let type;
        let operator;
        let value1;
        let value2;
        let ignoreBlank = true;
        let inCellDropDown = true;
        let isNew = true;
        const sheet = this.parent.getActiveSheet();
        let cell;
        let range = sheet.selectedRange;
        const indexes = getSwapRange(getRangeIndexes(range));
        range = this.getRange(range).range;
        const validationArgs = this.validateRange(indexes, sheet);
        if (!validationArgs.extendValidation && !validationArgs.moreValidation || okClick) {
            for (let rowIdx = indexes[0]; rowIdx <= indexes[2]; rowIdx++) {
                if (sheet.rows[rowIdx]) {
                    for (let colIdx = indexes[1]; colIdx <= indexes[3]; colIdx++) {
                        if (sheet.rows[rowIdx].cells && sheet.rows[rowIdx].cells[colIdx]) {
                            cell = sheet.rows[rowIdx].cells[colIdx];
                            if (cell.validation) {
                                isNew = false;
                                type = cell.validation.type;
                                operator = cell.validation.operator;
                                value1 = cell.validation.value1;
                                value2 = cell.validation.value2;
                                ignoreBlank = !isNullOrUndefined(cell.validation.ignoreBlank) ?
                                    cell.validation.ignoreBlank : ignoreBlank;
                                inCellDropDown = !isNullOrUndefined(cell.validation.inCellDropDown) ?
                                    cell.validation.inCellDropDown : inCellDropDown;
                            }
                        }
                    }
                }
            }
            if (isNew) {
                for (let i = indexes[1]; i <= indexes[3]; i++) {
                    const column = getColumn(sheet, i);
                    if (column && column.validation) {
                        isNew = false;
                        type = column.validation.type;
                        operator = column.validation.operator;
                        value1 = column.validation.value1;
                        value2 = column.validation.value2;
                        ignoreBlank = !isNullOrUndefined(column.validation.ignoreBlank) ?
                            column.validation.ignoreBlank : ignoreBlank;
                        inCellDropDown = !isNullOrUndefined(column.validation.inCellDropDown) ?
                            column.validation.inCellDropDown : inCellDropDown;
                    }
                }
            }
            if (!this.parent.element.querySelector('.e-datavalidation-dlg')) {
                const dialogInst = this.parent.serviceLocator.getService(dialog);
                dialogInst.show({
                    width: 375, showCloseIcon: true, isModal: true, cssClass: 'e-datavalidation-dlg',
                    header: l10n.getConstant('DataValidation'),
                    beforeOpen: (args) => {
                        const dlgArgs = {
                            dialogName: 'ValidationDialog', element: args.element,
                            target: args.target, cancel: args.cancel
                        };
                        this.parent.trigger('dialogBeforeOpen', dlgArgs);
                        if (dlgArgs.cancel) {
                            args.cancel = true;
                        }
                        if (noClick) {
                            isNew = true;
                        }
                        dialogInst.dialogInstance.content =
                            this.dataValidationContent(isNew, type, operator, value1, value2, ignoreBlank, inCellDropDown, range);
                        dialogInst.dialogInstance.dataBind();
                        focus(this.parent.element);
                    },
                    buttons: [{
                            buttonModel: {
                                content: l10n.getConstant('ClearAll'),
                                cssClass: 'e-btn e-clearall-btn e-flat'
                            },
                            click: () => {
                                dialogInst.dialogInstance.content =
                                    this.dataValidationContent(true, type, operator, value1, value2, ignoreBlank, inCellDropDown, range);
                                dialogInst.dialogInstance.dataBind();
                                focus(this.parent.element);
                            }
                        },
                        {
                            buttonModel: {
                                content: l10n.getConstant('Apply'), isPrimary: true
                            },
                            click: () => {
                                this.dlgClickHandler(dialogInst);
                            }
                        }]
                });
                dialogInst.dialogInstance.refresh();
            }
        }
        else {
            if (validationArgs.moreValidation) {
                this.moreValidationDlg();
            }
            if (validationArgs.extendValidation) {
                this.extendValidationDlg();
            }
        }
    }
    dataValidationContent(isNew, type, operator, val1, val2, ignoreBlank, inCellDropDown, range) {
        const l10n = this.parent.serviceLocator.getService(locale);
        const value1 = isNew ? '0' : val1;
        const value2 = isNew ? '0' : val2;
        const dlgContent = this.parent.createElement('div', { className: 'e-validation-dlg' });
        const cellRangeCont = this.parent.createElement('div', { className: 'e-cellrange' });
        const allowDataCont = this.parent.createElement('div', { className: 'e-allowdata' });
        const valuesCont = this.parent.createElement('div', { className: 'e-values' });
        const ignoreBlankCont = this.parent.createElement('div', { className: 'e-ignoreblank' });
        dlgContent.appendChild(cellRangeCont);
        dlgContent.appendChild(allowDataCont);
        dlgContent.appendChild(valuesCont);
        dlgContent.appendChild(ignoreBlankCont);
        const cellRangeText = this.parent.createElement('span', { className: 'e-header', innerHTML: l10n.getConstant('CellRange') });
        const cellRangeEle = this.parent.createElement('input', {
            className: 'e-input',
            attrs: { value: range, 'aria-label': l10n.getConstant('CellRange') }
        });
        cellRangeCont.appendChild(cellRangeText);
        cellRangeCont.appendChild(cellRangeEle);
        const allowCont = this.parent.createElement('div', { className: 'e-allow' });
        const dataCont = this.parent.createElement('div', { className: 'e-data' });
        allowDataCont.appendChild(allowCont);
        allowDataCont.appendChild(dataCont);
        const allowText = this.parent.createElement('span', { className: 'e-header', innerHTML: l10n.getConstant('Allow') });
        this.typeData = [
            { text: l10n.getConstant('WholeNumber'), id: 'type-1' },
            { text: l10n.getConstant('Decimal'), id: 'type-2' },
            { text: l10n.getConstant('Date'), id: 'type-3' },
            { text: l10n.getConstant('Time'), id: 'type-4' },
            { text: l10n.getConstant('TextLength'), id: 'type-5' },
            { text: l10n.getConstant('List'), id: 'type-6' }
        ];
        this.operatorData = [
            { text: l10n.getConstant('Between'), id: 'operator-1' },
            { text: l10n.getConstant('NotBetween'), id: 'operator-2' },
            { text: l10n.getConstant('EqualTo'), id: 'operator-3' },
            { text: l10n.getConstant('NotEqualTo'), id: 'operator-4' },
            { text: l10n.getConstant('GreaterThan'), id: 'operator-5' },
            { text: l10n.getConstant('LessThan'), id: 'operator-6' },
            { text: l10n.getConstant('GreaterThanOrEqualTo'), id: 'operator-7' },
            { text: l10n.getConstant('LessThanOrEqualTo'), id: 'operator-8' }
        ];
        const allowSelectEle = this.parent.createElement('input', { className: 'e-select' });
        if (type) {
            type = this.FormattedType(type);
        }
        let allowIdx = 0;
        if (!isNew) {
            for (let idx = 0; idx < this.typeData.length; idx++) {
                if (type === this.FormattedType(this.typeData[idx].text)) {
                    allowIdx = idx;
                    break;
                }
            }
        }
        if (isNew || type !== 'List') {
            let dataIdx = 0;
            const dataText = this.parent.createElement('span', { className: 'e-header', innerHTML: l10n.getConstant('Data') });
            const dataSelectEle = this.parent.createElement('input', { className: 'e-select' });
            if (!isNew) {
                for (let idx = 0; idx < this.operatorData.length; idx++) {
                    if (operator === this.FormattedValue(this.operatorData[idx].text)) {
                        dataIdx = idx;
                        break;
                    }
                }
            }
            dataCont.appendChild(dataText);
            dataCont.appendChild(dataSelectEle);
            this.dataList = new DropDownList({
                dataSource: this.operatorData,
                index: dataIdx,
                popupHeight: '200px',
                change: () => { this.userInput(listObj, this.dataList); }
            });
            this.dataList.appendTo(dataSelectEle);
        }
        else {
            const ignoreBlankEle = this.parent.createElement('input', { className: 'e-checkbox' });
            dataCont.appendChild(ignoreBlankEle);
            const ignoreBlankObj = new CheckBox({ label: l10n.getConstant('InCellDropDown'), checked: inCellDropDown });
            ignoreBlankObj.appendTo(ignoreBlankEle);
        }
        allowCont.appendChild(allowText);
        allowCont.appendChild(allowSelectEle);
        const listObj = new DropDownList({
            dataSource: this.typeData,
            index: allowIdx,
            popupHeight: '200px',
            change: () => { this.userInput(listObj, this.dataList); }
        });
        listObj.appendTo(allowSelectEle);
        if (isNew || (listObj.value !== l10n.getConstant('List') && (this.dataList.value === l10n.getConstant('Between') || this.dataList.value === l10n.getConstant('NotBetween')))) {
            const minimumCont = this.parent.createElement('div', { className: 'e-minimum' });
            const maximumCont = this.parent.createElement('div', { className: 'e-maximum' });
            valuesCont.appendChild(minimumCont);
            valuesCont.appendChild(maximumCont);
            const minimumText = this.parent.createElement('span', { className: 'e-header', innerHTML: l10n.getConstant('Minimum') });
            const maximumText = this.parent.createElement('span', { className: 'e-header', innerHTML: l10n.getConstant('Maximum') });
            const minimumInp = this.parent.createElement('input', {
                id: 'minvalue',
                className: 'e-input', attrs: { value: value1, 'aria-label': l10n.getConstant('Minimum') }
            });
            const maximumInp = this.parent.createElement('input', {
                id: 'maxvalue',
                className: 'e-input', attrs: { value: value2, 'aria-label': l10n.getConstant('Maximum') }
            });
            minimumCont.appendChild(minimumText);
            minimumCont.appendChild(minimumInp);
            maximumCont.appendChild(maximumText);
            maximumCont.appendChild(maximumInp);
            const numericMin = new NumericTextBox({
                value: 0
            });
            numericMin.appendTo('#minvalue');
            const numericMax = new NumericTextBox({
                value: 0
            });
            numericMax.appendTo('#maxvalue');
        }
        else if (!isNew && type === 'List') {
            const valueText = this.parent.createElement('span', {
                className: 'e-header', innerHTML: l10n.getConstant('Sources')
            });
            const valueEle = this.parent.createElement('input', { className: 'e-input', attrs: { value: value1 } });
            valuesCont.appendChild(valueText);
            valuesCont.appendChild(valueEle);
        }
        else {
            const valueText = this.parent.createElement('span', {
                className: 'e-header', innerHTML: l10n.getConstant('Value')
            });
            const valueEle = this.parent.createElement('input', { className: 'e-input', attrs: { value: value1 } });
            valuesCont.appendChild(valueText);
            valuesCont.appendChild(valueEle);
        }
        const isChecked = ignoreBlank;
        const ignoreBlankEle = this.parent.createElement('input', { className: 'e-checkbox' });
        ignoreBlankCont.appendChild(ignoreBlankEle);
        const ignoreBlankObj = new CheckBox({ label: l10n.getConstant('IgnoreBlank'), checked: isChecked });
        ignoreBlankObj.appendTo(ignoreBlankEle);
        return dlgContent;
    }
    validateRange(indexes, sheet) {
        let moreValidation = false;
        let extendValidation = false;
        const type = [];
        const operator = [];
        const value1 = [];
        const value2 = [];
        for (let rowIndex = indexes[0]; rowIndex <= indexes[2]; rowIndex++) {
            if (sheet.rows[rowIndex]) {
                for (let colIdx = indexes[1]; colIdx <= indexes[3]; colIdx++) {
                    if (sheet.rows[rowIndex].cells && sheet.rows[rowIndex].cells[colIdx]) {
                        const cell = sheet.rows[rowIndex].cells[colIdx];
                        if (cell.validation) {
                            type.push(cell.validation.type);
                            operator.push(cell.validation.operator);
                            value1.push(cell.validation.value1);
                            value2.push(cell.validation.value2);
                        }
                    }
                }
            }
        }
        for (let i = indexes[1]; i <= indexes[3]; i++) {
            const column = getColumn(sheet, i);
            if (column && column.validation) {
                type.push(column.validation.type);
                operator.push(column.validation.operator);
                value1.push(column.validation.value1);
                value2.push(column.validation.value2);
            }
        }
        let tmp = [];
        for (let i = 0; i < type.length; i++) {
            if (tmp.indexOf(type[i]) === -1) {
                tmp.push(type[i]);
            }
        }
        if (tmp.length > 1) {
            moreValidation = true;
        }
        if (!moreValidation) {
            tmp = [];
            for (let j = 0; j < operator.length; j++) {
                if (tmp.indexOf(operator[j]) === -1) {
                    tmp.push(operator[j]);
                }
            }
            if (tmp.length > 1) {
                moreValidation = true;
            }
        }
        if (!moreValidation) {
            tmp = [];
            for (let j = 0; j < value1.length; j++) {
                if (tmp.indexOf(value1[j]) === -1) {
                    tmp.push(value1[j]);
                }
            }
            if (tmp.length > 1) {
                moreValidation = true;
            }
        }
        if (!moreValidation) {
            tmp = [];
            for (let j = 0; j < value2.length; j++) {
                if (tmp.indexOf(value2[j]) === -1) {
                    tmp.push(value2[j]);
                }
            }
            if (tmp.length > 1) {
                moreValidation = true;
            }
        }
        if (!moreValidation) {
            let count = 0;
            let cellCount = 0;
            for (let startRow = indexes[0]; startRow <= indexes[2]; startRow++) {
                if (sheet.rows[startRow]) {
                    for (let colIdx = indexes[1]; colIdx <= indexes[3]; colIdx++) {
                        if (sheet.rows[startRow].cells && sheet.rows[startRow].cells[colIdx]) {
                            const cell = sheet.rows[startRow].cells[colIdx];
                            cellCount++;
                            if (cell.validation) {
                                count++;
                            }
                        }
                    }
                }
            }
            if (count === 0) {
                for (let i = indexes[1]; i <= indexes[3]; i++) {
                    const column = getColumn(sheet, i);
                    if (column && column.validation) {
                        count++;
                    }
                }
            }
            if (count > 0 && cellCount > 1 && count !== cellCount) {
                extendValidation = true;
            }
        }
        return { moreValidation: moreValidation, extendValidation: extendValidation };
    }
    moreValidationDlg() {
        const l10n = this.parent.serviceLocator.getService(locale);
        const dialogInst = this.parent.serviceLocator.getService(dialog);
        let skip = false;
        const dlg = {
            width: 350, isModal: true, showCloseIcon: true, cssClass: 'e-goto-dlg',
            header: l10n.getConstant('Spreadsheet'),
            beforeOpen: (args) => {
                const dlgArgs = {
                    dialogName: 'MoreValidation',
                    element: args.element, target: args.target, cancel: args.cancel
                };
                this.parent.trigger('dialogBeforeOpen', dlgArgs);
                if (dlgArgs.cancel) {
                    args.cancel = true;
                }
                dialogInst.dialogInstance.content = l10n.getConstant('MoreValidation');
                dialogInst.dialogInstance.dataBind();
                focus(this.parent.element);
            },
            buttons: [{
                    buttonModel: {
                        content: l10n.getConstant('Ok'), isPrimary: true, cssClass: 'e-btn-goto-ok'
                    },
                    click: () => {
                        dialogInst.hide();
                        skip = true;
                    }
                }], close: () => {
                if (skip) {
                    this.initiateDataValidationHandler(true);
                    skip = false;
                }
                else {
                    dialogInst.hide();
                }
            }
        };
        dialogInst.show(dlg);
    }
    extendValidationDlg() {
        const l10n = this.parent.serviceLocator.getService(locale);
        const dialogInst = this.parent.serviceLocator.getService(dialog);
        let skip = false;
        let noClick = false;
        const dlg = {
            width: 550, isModal: true, showCloseIcon: true, cssClass: 'e-goto-dlg',
            header: l10n.getConstant('Spreadsheet'),
            beforeOpen: (args) => {
                const dlgArgs = {
                    dialogName: 'ExtendValidation',
                    element: args.element, target: args.target, cancel: args.cancel
                };
                this.parent.trigger('dialogBeforeOpen', dlgArgs);
                if (dlgArgs.cancel) {
                    args.cancel = true;
                }
                dialogInst.dialogInstance.content = l10n.getConstant('ExtendValidation');
                dialogInst.dialogInstance.dataBind();
                focus(this.parent.element);
            },
            buttons: [{
                    buttonModel: {
                        content: l10n.getConstant('Yes'), isPrimary: true, cssClass: 'e-btn-goto-ok'
                    },
                    click: () => {
                        dialogInst.hide();
                        skip = true;
                    }
                },
                {
                    buttonModel: {
                        content: l10n.getConstant('No'), isPrimary: true, cssClass: 'e-btn-goto-ok'
                    },
                    click: () => {
                        dialogInst.hide();
                        skip = true;
                        noClick = true;
                    }
                }], close: () => {
                if (skip) {
                    this.initiateDataValidationHandler(true, noClick);
                    skip = false;
                }
                else {
                    dialogInst.hide();
                }
            }
        };
        dialogInst.show(dlg);
    }
    userInput(listObj, listObj1) {
        const dlgEle = this.parent.element.querySelector('.e-datavalidation-dlg');
        const dlgCont = dlgEle.querySelector('.e-validation-dlg');
        const allowDataCont = dlgCont.querySelector('.e-allowdata');
        const valuesCont = dlgCont.querySelector('.e-values');
        const l10n = this.parent.serviceLocator.getService(locale);
        const dataCont = allowDataCont.querySelector('.e-data');
        while (valuesCont.lastChild) {
            valuesCont.removeChild(valuesCont.lastChild);
        }
        if (listObj.value === l10n.getConstant('List')) {
            while (dataCont.lastChild) {
                dataCont.removeChild(dataCont.lastChild);
            }
            const ignoreBlankEle = this.parent.createElement('input', { className: 'e-checkbox' });
            dataCont.appendChild(ignoreBlankEle);
            const ignoreBlankObj = new CheckBox({ label: l10n.getConstant('InCellDropDown'), checked: true });
            ignoreBlankObj.appendTo(ignoreBlankEle);
        }
        else {
            if (dataCont.getElementsByClassName('e-checkbox-wrapper')[0]) {
                while (dataCont.lastChild) {
                    dataCont.removeChild(dataCont.lastChild);
                }
                const dataText = this.parent.createElement('span', { className: 'e-header', innerHTML: 'Data' });
                const dataSelectEle = this.parent.createElement('input', { className: 'e-select' });
                dataCont.appendChild(dataText);
                dataCont.appendChild(dataSelectEle);
                listObj1.appendTo(dataSelectEle);
            }
        }
        if (listObj.value !== l10n.getConstant('List') && (listObj1.value === l10n.getConstant('Between') || listObj1.value === l10n.getConstant('NotBetween'))) {
            const minimumCont = this.parent.createElement('div', { className: 'e-minimum' });
            const maximumCont = this.parent.createElement('div', { className: 'e-maximum' });
            valuesCont.appendChild(minimumCont);
            valuesCont.appendChild(maximumCont);
            const minimumText = this.parent.createElement('span', { className: 'e-header', innerHTML: l10n.getConstant('Minimum') });
            const maximumText = this.parent.createElement('span', { className: 'e-header', innerHTML: l10n.getConstant('Maximum') });
            const minimumInp = this.parent.createElement('input', { id: 'min', className: 'e-input', attrs: { value: '0' } });
            const maximumInp = this.parent.createElement('input', { id: 'max', className: 'e-input', attrs: { value: '0' } });
            const numericMin = new NumericTextBox({
                value: 0
            });
            numericMin.appendTo('min');
            const numericMax = new NumericTextBox({
                value: 0
            });
            numericMax.appendTo('max');
            minimumCont.appendChild(minimumText);
            minimumCont.appendChild(minimumInp);
            maximumCont.appendChild(maximumText);
            maximumCont.appendChild(maximumInp);
        }
        else {
            const text = listObj.value === l10n.getConstant('List') ? l10n.getConstant('Sources') : l10n.getConstant('Value');
            const valueText = this.parent.createElement('span', { className: 'e-header', innerHTML: text });
            const valueEle = listObj.value === l10n.getConstant('List') ? this.parent.createElement('input', {
                className: 'e-input',
                attrs: { placeholder: 'Enter value' }
            }) :
                this.parent.createElement('input', { className: 'e-input', attrs: { value: '0' } });
            valuesCont.appendChild(valueText);
            valuesCont.appendChild(valueEle);
        }
    }
    dlgClickHandler(dialogInst) {
        const l10n = this.parent.serviceLocator.getService(locale);
        let errorMsg;
        const dlgEle = this.parent.element.querySelector('.e-datavalidation-dlg');
        const dlgFooter = dlgEle.querySelector('.e-footer-content');
        const dlgContEle = dlgEle.getElementsByClassName('e-dlg-content')[0].
            getElementsByClassName('e-validation-dlg')[0];
        const allowData = dlgContEle.getElementsByClassName('e-allowdata')[0];
        const allowEle = allowData.getElementsByClassName('e-allow')[0].getElementsByTagName('input')[0];
        const dataEle = allowData.getElementsByClassName('e-data')[0].getElementsByTagName('input')[0];
        const values = dlgContEle.getElementsByClassName('e-values')[0];
        const valueArr = [];
        valueArr[0] = values.getElementsByTagName('input')[0].value;
        valueArr[1] = values.getElementsByTagName('input')[1] ? values.getElementsByTagName('input')[1].value : '';
        parseLocaleNumber(valueArr, this.parent.locale);
        const ignoreBlank = dlgContEle.querySelector('.e-ignoreblank .e-checkbox').checked;
        const inCellDropDown = allowData.querySelector('.e-data').querySelector('.e-checkbox-wrapper') ?
            allowData.querySelector('.e-data').querySelector('.e-checkbox-wrapper').querySelector('.e-check') ? true : false : null;
        const range = dlgContEle.querySelector('.e-cellrange').getElementsByTagName('input')[0].value;
        let operator;
        let type = allowEle.value;
        type = this.FormattedType(type);
        if (dataEle) {
            operator = dataEle.value;
            operator = this.FormattedValue(operator);
        }
        let rangeAdd = [];
        const valArr = [];
        if (valueArr[0] !== '') {
            valArr.push(valueArr[0]);
        }
        if (valueArr[1] !== '') {
            valArr.push(valueArr[1]);
        }
        let isValid = true;
        if (type === 'List') {
            if (valueArr[0].indexOf('=') !== -1) {
                if (valueArr[0].indexOf(':') !== -1) {
                    const address = valueArr[0].indexOf('!') > -1 ? valueArr[0].split('!')[1] : valueArr[0].split('=')[1];
                    const isSheetNameValid = valueArr[0].indexOf('!') > -1 ?
                        getSheetIndex(this.parent, valueArr[0].split('=')[1].split('!')[0]) > -1 : true;
                    rangeAdd = address.split(':');
                    const isSingleCol = address.match(/[a-z]/gi) ?
                        rangeAdd[0].replace(/[0-9]/g, '') === rangeAdd[1].replace(/[0-9]/g, '') : false;
                    const isSingleRow = address.match(/\d/g) ?
                        rangeAdd[0].replace(/\D/g, '') === rangeAdd[1].replace(/\D/g, '') : false;
                    isValid = isSheetNameValid ? (isSingleCol ? true : isSingleRow ? true : false) : false;
                    if (!isValid) {
                        errorMsg = l10n.getConstant('DialogError');
                    }
                }
            }
            else if (valueArr[0].length > 256) {
                isValid = false;
                errorMsg = l10n.getConstant('ListLengthError');
            }
        }
        if (isValid) {
            const sheet = this.parent.getActiveSheet();
            const format = type;
            const validDlg = this.isDialogValidator(valArr, format, operator);
            if (operator === 'Between') {
                if (!isNaN(parseFloat(valueArr[0])) && !isNaN(parseFloat(valueArr[1])) &&
                    parseFloat(valueArr[0]) > parseFloat(valueArr[1])) {
                    validDlg.isValidate = false;
                    validDlg.errorMsg = l10n.getConstant('MinMaxError');
                }
            }
            errorMsg = validDlg.errorMsg;
            isValid = validDlg.isValidate;
            if (isValid) {
                const indexes = getCellIndexes(sheet.activeCell);
                let cell = getCell(indexes[0], indexes[1], sheet, false, true);
                const isListValidationApplied = cell.validation && cell.validation.type === 'List';
                const args = { range: sheet.name + '!' + range, value1: valueArr[0], value2: valueArr[1],
                    ignoreBlank: ignoreBlank, type: type, operator: operator, inCellDropDown: inCellDropDown, cancel: false };
                this.parent.notify(beginAction, { eventArgs: args, action: 'validation' });
                if (!args.cancel) {
                    this.parent.notify(cellValidation, { rules: { type: args.type, operator: args.operator, value1: args.value1, value2: args.value2,
                            ignoreBlank: args.ignoreBlank, inCellDropDown: args.inCellDropDown }, range: args.range });
                    cell = getCell(indexes[0], indexes[1], sheet, false, true);
                    if (cell.validation) {
                        if (isListValidationApplied) {
                            const tdEle = this.parent.getCell(indexes[0], indexes[1]);
                            if (tdEle && tdEle.getElementsByClassName('e-validation-list')[0]) {
                                this.listObj.destroy();
                                tdEle.removeChild(tdEle.getElementsByClassName('e-validation-list')[0]);
                            }
                        }
                        if (cell.validation.type === 'List') {
                            this.listHandler();
                        }
                    }
                    delete args.cancel;
                    if (!document.getElementsByClassName('e-validationerror-dlg')[0]) {
                        if (dialogInst.dialogInstance) {
                            dialogInst.dialogInstance.hide();
                        }
                        else {
                            dialogInst.hide();
                        }
                    }
                    this.parent.notify(completeAction, { eventArgs: args, action: 'validation' });
                }
            }
        }
        if (!isValid) {
            const errorEle = this.parent.createElement('div', {
                className: 'e-dlg-error', id: 'e-invalid', innerHTML: errorMsg
            });
            values.appendChild(errorEle);
            dlgFooter.querySelector('.e-primary').setAttribute('disabled', 'true');
        }
    }
    FormattedValue(value) {
        const l10n = this.parent.serviceLocator.getService(locale);
        switch (value) {
            case l10n.getConstant('Between'):
                value = 'Between';
                break;
            case l10n.getConstant('NotBetween'):
                value = 'NotBetween';
                break;
            case l10n.getConstant('EqualTo'):
                value = 'EqualTo';
                break;
            case l10n.getConstant('NotEqualTo'):
                value = 'NotEqualTo';
                break;
            case l10n.getConstant('GreaterThan'):
                value = 'GreaterThan';
                break;
            case l10n.getConstant('LessThan'):
                value = 'LessThan';
                break;
            case l10n.getConstant('GreaterThanOrEqualTo'):
                value = 'GreaterThanOrEqualTo';
                break;
            case l10n.getConstant('LessThanOrEqualTo'):
                value = 'LessThanOrEqualTo';
                break;
            default:
                value = 'Between';
                break;
        }
        return value;
    }
    FormattedType(value) {
        const l10n = this.parent.serviceLocator.getService(locale);
        switch (value) {
            case l10n.getConstant('WholeNumber'):
                value = 'WholeNumber';
                break;
            case l10n.getConstant('Decimal'):
                value = 'Decimal';
                break;
            case l10n.getConstant('Date'):
                value = 'Date';
                break;
            case l10n.getConstant('TextLength'):
                value = 'TextLength';
                break;
            case l10n.getConstant('List'):
                value = 'List';
                break;
            case l10n.getConstant('Time'):
                value = 'Time';
                break;
            default:
                break;
        }
        return value;
    }
    isDialogValidator(values, type, operator) {
        const l10n = this.parent.serviceLocator.getService(locale);
        let count = 0;
        let isEmpty = false;
        let formValidation;
        if (type === 'List') {
            isEmpty = values.length > 0 ? false : true;
        }
        else {
            if (operator === 'Between' || operator === 'NotBetween') {
                isEmpty = values.length === 2 ? false : true;
            }
            else {
                isEmpty = values.length > 0 ? false : true;
            }
        }
        if (!isEmpty) {
            for (let idx = 0; idx < values.length; idx++) {
                const value = checkIsFormula(values[idx]) ? this.parent.computeExpression(values[idx]).toString() : values[idx];
                formValidation = this.formatValidation(value, type, true);
                if (formValidation.isValidate) {
                    count = count + 1;
                }
                else {
                    break;
                }
            }
            formValidation.isValidate = count === values.length ? true : false;
        }
        else {
            formValidation = { isValidate: false, errorMsg: l10n.getConstant('EmptyError') };
        }
        return { isValidate: formValidation.isValidate, errorMsg: formValidation.errorMsg };
    }
    isValidationHandler(args) {
        const l10n = this.parent.serviceLocator.getService(locale);
        args.value = args.value ? args.value : '';
        let isValidate;
        let errorMsg;
        const enterValue = args.value;
        const sheet = this.parent.sheets[args.sheetIdx];
        let validation;
        const cell = getCell(args.range[0], args.range[1], sheet);
        const column = getColumn(sheet, args.range[1]);
        if (cell && cell.validation) {
            validation = cell.validation;
        }
        else if (checkColumnValidation(column, args.range[0], args.range[1])) {
            validation = column.validation;
        }
        if (validation) {
            let value1 = validation.value1;
            let value2 = validation.value2;
            if (checkIsFormula(value1) && validation.type !== 'List') {
                value1 = this.parent.computeExpression(value1).toString();
            }
            if (checkIsFormula(value2) && validation.type !== 'List') {
                value2 = this.parent.computeExpression(value2).toString();
            }
            if (checkIsFormula(args.value) && validation.type !== 'List') {
                args.value = this.parent.computeExpression(args.value).toString();
            }
            let value = args.value;
            const opt = validation.operator || 'Between';
            const type = validation.type || 'WholeNumber';
            const ignoreBlank = isNullOrUndefined(validation.ignoreBlank) ? true : validation.ignoreBlank;
            if (ignoreBlank && enterValue === '') {
                isValidate = true;
            }
            else {
                const formValidation = this.formatValidation(args.value, type);
                isValidate = formValidation.isValidate;
                errorMsg = formValidation.errorMsg;
                if (isValidate) {
                    isValidate = false;
                    if (type === 'Date' || type === 'Time') {
                        args.value = args.value.toString().slice(args.value.toString().indexOf(' ') + 1, args.value.length);
                        for (let idx = 0; idx < 3; idx++) {
                            args.value = idx === 0 ? args.value : idx === 1 ? value1 : value2;
                            const dateEventArgs = {
                                value: args.value,
                                rowIndex: args.range[0],
                                colIndex: args.range[1],
                                sheetIndex: args.sheetIdx,
                                updatedVal: ''
                            };
                            if (args.value !== '') {
                                this.parent.notify(checkDateFormat, dateEventArgs);
                            }
                            let updatedVal = dateEventArgs.updatedVal;
                            updatedVal = updatedVal === '' ? args.value : updatedVal;
                            if (idx === 0) {
                                value = updatedVal;
                            }
                            else if (idx === 1) {
                                value1 = updatedVal;
                            }
                            else {
                                value2 = updatedVal;
                            }
                        }
                    }
                    else if (validation.type === 'TextLength') {
                        const dateEventArgs = {
                            value: args.value,
                            rowIndex: args.range[0],
                            colIndex: args.range[1],
                            sheetIndex: args.sheetIdx,
                            updatedVal: ''
                        };
                        this.parent.notify(checkDateFormat, dateEventArgs);
                        const updatedVal = dateEventArgs.updatedVal;
                        if (updatedVal !== '') {
                            value = updatedVal.toString().length.toString();
                        }
                        else {
                            value = args.value.toString().length.toString();
                        }
                    }
                    if (type === 'List') {
                        if (value1.indexOf('=') !== -1) {
                            for (let idx = 0; idx < this.data.length; idx++) {
                                if (args.value.toString() === this.data[idx].text) {
                                    isValidate = true;
                                }
                            }
                        }
                        else {
                            const values = value1.split(',');
                            for (let idx = 0; idx < values.length; idx++) {
                                if (args.value.toString() === values[idx]) {
                                    isValidate = true;
                                }
                            }
                        }
                        if (!isValidate && ignoreBlank && args.value.toString() === '') {
                            isValidate = true;
                        }
                    }
                    else {
                        if (type === 'Decimal' || type === 'Time') {
                            value = parseFloat(value.toString());
                            value1 = parseFloat(value1.toString());
                            value2 = value2 ? parseFloat(value2.toString()) : null;
                        }
                        else {
                            value = parseInt(value.toString(), 10);
                            value1 = parseInt(value1.toString(), 10);
                            value2 = value2 ? parseInt(value2.toString(), 10) : null;
                        }
                        switch (opt) {
                            case 'EqualTo':
                                if (value === value1) {
                                    isValidate = true;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = false;
                                }
                                break;
                            case 'NotEqualTo':
                                if (value !== value1) {
                                    isValidate = true;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = false;
                                }
                                break;
                            case 'Between':
                                if (value >= value1 && value <= value2) {
                                    isValidate = true;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = false;
                                }
                                break;
                            case 'NotBetween':
                                if (value >= value1 && value <= value2) {
                                    isValidate = false;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = true;
                                }
                                break;
                            case 'GreaterThan':
                                if (value > value1) {
                                    isValidate = true;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = false;
                                }
                                break;
                            case 'LessThan':
                                if (value < value1) {
                                    isValidate = true;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = false;
                                }
                                break;
                            case 'GreaterThanOrEqualTo':
                                if (value >= value1) {
                                    isValidate = true;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = false;
                                }
                                break;
                            case 'LessThanOrEqualTo':
                                if (value <= value1) {
                                    isValidate = true;
                                }
                                else if (ignoreBlank && enterValue === '') {
                                    isValidate = true;
                                }
                                else {
                                    isValidate = false;
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }
            }
        }
        errorMsg = l10n.getConstant('ValidationError');
        if (isValidate && cell && cell.validation && cell.validation.isHighlighted) {
            const style = this.parent.getCellStyleValue(['backgroundColor', 'color'], [args.range[0], args.range[1]]);
            if (!isHiddenRow(sheet, args.range[0])) {
                this.parent.notify(applyCellFormat, {
                    style: style, rowIdx: args.range[0], colIdx: args.range[1], isHeightCheckNeeded: true, manualUpdate: true,
                    onActionUpdate: true, cell: args.td
                });
            }
        }
        return { isValidate: isValidate, errorMsg: errorMsg };
    }
    checkDataValidation(args) {
        const cell = getCell(args.range[0], args.range[1], this.parent.getActiveSheet());
        args.td = args.td || this.parent.getCell(args.range[0], args.range[1]);
        args.sheetIdx = args.sheetIdx || this.parent.activeSheetIndex;
        const formulaArgs = { skip: false, value: '' };
        if (cell && cell.validation) {
            if (checkIsFormula(cell.validation.value1) &&
                !isCellReference(cell.validation.value1.substring(1, cell.validation.value1.length)) &&
                cell.validation.value1.indexOf('(') > -1) {
                let val = cell.validation.value1;
                val = val.substring(val.indexOf('=') + 1, val.indexOf('('));
                formulaArgs.value = val.toUpperCase();
                this.parent.notify(formulaInValidation, formulaArgs);
            }
            if (!formulaArgs.skip && checkIsFormula(cell.validation.value2) &&
                !isCellReference(cell.validation.value2.substring(1, cell.validation.value2.length)) &&
                cell.validation.value1.indexOf('(') > -1) {
                let val2 = cell.validation.value2;
                val2 = val2.substring(val2.indexOf('=') + 1, val2.indexOf('('));
                formulaArgs.value = val2.toUpperCase();
                this.parent.notify(formulaInValidation, formulaArgs);
            }
        }
        if (!formulaArgs.skip) {
            const isValid = this.isValidationHandler({
                value: args.value, range: args.range, sheetIdx: args.sheetIdx, td: args.td
            });
            if (!isValid.isValidate && args.isCell) {
                this.validationErrorHandler(isValid.errorMsg);
            }
            args.isValid = isValid.isValidate;
        }
    }
    formatValidation(value, type, isDialogValidator) {
        const sheetPanel = this.parent.element.getElementsByClassName('e-sheet-panel')[0];
        let errorMsg;
        const formEle = this.parent.createElement('form', {
            id: 'formId',
            className: 'form-horizontal'
        });
        const inputEle = this.parent.createElement('input', {
            id: 'e-validation', innerHTML: value
        });
        inputEle.setAttribute('name', 'validation');
        inputEle.setAttribute('type', 'text');
        inputEle.setAttribute('value', value);
        formEle.appendChild(inputEle);
        sheetPanel.appendChild(formEle);
        let options;
        switch (type) {
            case 'Date':
                options = {
                    rules: {
                        'validation': { date: true }
                    },
                    customPlacement: (inputElement, error) => {
                        errorMsg = error.innerText;
                    }
                };
                break;
            case 'Decimal':
                options = {
                    rules: {
                        'validation': { number: true }
                    },
                    customPlacement: (inputElement, error) => {
                        errorMsg = error.innerText;
                    }
                };
                break;
            case 'WholeNumber':
                options = {
                    rules: {
                        'validation': { regex: /^-?\d*\.?[0]*$/ }
                    },
                    customPlacement: (inputElement, error) => {
                        errorMsg = error.innerText;
                    }
                };
                break;
            case 'TextLength':
                if (isDialogValidator) {
                    options = {
                        rules: {
                            'validation': { regex: /^\d*\.?[0]*$/ }
                        },
                        customPlacement: (inputElement, error) => {
                            errorMsg = error.innerText;
                        }
                    };
                }
                break;
            default:
                break;
        }
        const formObj = new FormValidator('#formId', options);
        const isValidate = formObj.validate();
        sheetPanel.removeChild(sheetPanel.getElementsByClassName('form-horizontal')[0]);
        return { isValidate: isValidate, errorMsg: errorMsg };
    }
    InvalidElementHandler(args) {
        const rowIdx = args.rowIdx;
        const colIdx = args.colIdx;
        const isRemoveHighlightedData = args.isRemoveHighlightedData;
        if (!isRemoveHighlightedData) {
            this.parent.notify(applyCellFormat, {
                style: { backgroundColor: '#ffff00', color: '#ff0000' }, rowIdx: rowIdx, colIdx: colIdx, cell: args.td
            });
        }
        else if (isRemoveHighlightedData) {
            const style = this.parent.getCellStyleValue(['backgroundColor', 'color'], [rowIdx, colIdx]);
            this.parent.notify(applyCellFormat, {
                style: style, rowIdx: rowIdx, colIdx: colIdx, cell: args.td
            });
        }
    }
    validationErrorHandler(error) {
        const el = document.getElementsByClassName('e-spreadsheet-edit')[0];
        const l10n = this.parent.serviceLocator.getService(locale);
        if (!this.parent.element.querySelector('.e-validationerror-dlg')) {
            const erroDialogInst = this.parent.serviceLocator.getService(dialog);
            const disableCancel = false;
            const dlgModel = {
                width: 400, height: 200, isModal: true, showCloseIcon: true, cssClass: 'e-validationerror-dlg',
                target: document.querySelector('.e-control.e-spreadsheet'),
                beforeOpen: (args) => {
                    const dlgArgs = {
                        dialogName: 'ValidationErrorDialog',
                        element: args.element, target: args.target, cancel: args.cancel, content: error
                    };
                    this.parent.trigger('dialogBeforeOpen', dlgArgs);
                    if (dlgArgs.cancel) {
                        this.errorDlgHandler(erroDialogInst, 'Cancel');
                        args.cancel = true;
                    }
                    el.focus();
                    erroDialogInst.dialogInstance.content = dlgArgs.content;
                    erroDialogInst.dialogInstance.dataBind();
                },
                buttons: [{
                        buttonModel: {
                            content: l10n.getConstant('Retry'), isPrimary: true
                        },
                        click: () => {
                            this.errorDlgHandler(erroDialogInst, 'Retry');
                        }
                    },
                    {
                        buttonModel: {
                            content: l10n.getConstant('Cancel')
                        },
                        click: () => {
                            this.errorDlgHandler(erroDialogInst, 'Cancel');
                        }
                    }]
            };
            erroDialogInst.show(dlgModel, disableCancel);
        }
    }
    errorDlgHandler(errorDialogInst, buttonName) {
        if (buttonName === 'Retry') {
            const el = document.getElementsByClassName('e-spreadsheet-edit')[0];
            errorDialogInst.hide();
            if (el.innerText) {
                window.getSelection().selectAllChildren(el);
                if (this.listObj) {
                    this.listObj.showPopup();
                }
            }
        }
        else {
            const indexes = getCellIndexes(this.parent.getActiveSheet().activeCell);
            const cell = getCell(indexes[0], indexes[1], this.parent.getActiveSheet());
            const value = cell ? this.parent.getDisplayText(cell) : '';
            this.parent.notify(editOperation, {
                action: 'cancelEdit', value: value, refreshFormulaBar: true,
                refreshEditorElem: true, isAppend: false, trigEvent: true
            });
            errorDialogInst.hide();
        }
    }
    /**
     * Gets the module name.
     *
     * @returns {string} - Gets the module name.
     */
    getModuleName() {
        return 'dataValidation';
    }
}
